export enum WorkType {
  Task = 0,
  Haccp = 1,
}
